import React from "react";
import { sendEvent } from "../../../../helpers/analytics";

export const TellUsMoreCTA = ({
  handleClick,
  tellUsMoreCardRef
}) => {
  return (
    <>
      <div className="ch-display--flex ch-flex-flow--column-wrap ch-mb--4">
        <p
          className="ch-text--center ch-mb--0 ch-fs--2 mot-lh-24"
          data-testid="mot-expired-text"
        >
          You can tell us more about your car{" "}
          <span
            className="ch-btn--link tell-us-more--open-modal"
            onClick={() => {
              sendEvent("event", "interaction", {
                label: "Tell us more about your car"
              });
              handleClick(tellUsMoreCardRef);
            }}
          >
            here
          </span>
          .
        </p>
      </div>
    </>
  );
};
